export const getAuditImgUrl = (name: string) => `${process.env.REACT_APP_BASE_CONTENT_URL}/${name}/cover.png`;

export const getAuditPDF = (name: string, path: string) =>
  `${process.env.REACT_APP_BASE_CONTENT_URL}/${name}/${path}.pdf`;
